import React from "react";

const ProcessFlow = () => {
  return (
    <section className="w-full py-16 bg-gray-50">
      <div className="container mx-auto px-4">

        {/* Heading */}
        <h1 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent text-center mb-12">
          Our Turf Installation Process
        </h1>

        {/* Two Columns */}
        <div className="flex flex-col lg:flex-row gap-10 items-center justify-center">

          {/* Left Column: Main Image */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src="/Images/turf-main.jpg"
              alt="Turf Installation"
              className="w-full max-w-sm md:max-w-md lg:max-w-lg rounded-xl shadow-lg object-cover"
            />
          </div>

          {/* Right Column: Stacked Images */}
          <div className="w-full lg:w-1/2 flex flex-col gap-6">
            <img
              src="/Images/turf-step1.jpg"
              alt="Base Preparation"
              className="w-full max-w-sm md:max-w-md lg:max-w-lg rounded-xl shadow-lg object-cover"
            />

            <img
              src="/Images/turf-step2.jpg"
              alt="Turf Laying"
              className="w-full max-w-sm md:max-w-md lg:max-w-lg rounded-xl shadow-lg object-cover"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProcessFlow;
